module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-50.94b14ef7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-50.png
// module id = 3334
// module chunks = 11